import * as Yup from 'yup'

export const AddSpaceFormValidator = Yup.object().shape({
  values: Yup.array().of(
    Yup.object().shape({
      quantity: Yup.number().integer().min(1, 'Quantity can not be less than 1.').required(),
    }),
  ),
})
